<ng-container *transloco="let t; prefix: 'dialog'">
  <header>
    <h1 mat-dialog-title>{{ titleKey() | transloco }}</h1>
  </header>

  @if (isInitialized()) {
    <div mat-dialog-content>
      <ng-content select="[dialogContent]"></ng-content>
    </div>
  } @else {
    <mat-spinner />
  }

  <div mat-dialog-actions>
    <button mat-button (click)="cancel$.next()">
      {{ t('button.close.label') }}
    </button>

    <button mat-button (click)="save$.next()" [disabled]="formGroup().invalid">
      {{ t('button.submit.label') }}
    </button>
  </div>
</ng-container>
